import { render, staticRenderFns } from "./RmpMasterAccountAccess.vue?vue&type=template&id=7f3db136&scoped=true"
import script from "./RmpMasterAccountAccess.vue?vue&type=script&setup=true&lang=ts"
export * from "./RmpMasterAccountAccess.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./RmpMasterAccountAccess.vue?vue&type=style&index=0&id=7f3db136&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f3db136",
  null
  
)

export default component.exports